class MobileBottomNav {
  constructor() {
    this.nav = document.querySelector('.mobile-bottom-nav');
    if (!this.nav) return;
    this.badge = this.nav.querySelector('.mobile-bottom-nav__badge');
    this.initBadge();
    this.initActiveState();
  }

  async initBadge() {
    await this.updateBadge();
    document.addEventListener('cart:updated', () => this.updateBadge());
  }

  async updateBadge() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count || 0;
      if (!this.badge) return;
      if (count > 0) {
        this.badge.textContent = count > 99 ? '99+' : count;
        this.badge.classList.add('mobile-bottom-nav__badge--visible');
        this.badge.classList.remove('mobile-bottom-nav__badge--bump');
        requestAnimationFrame(() => this.badge.classList.add('mobile-bottom-nav__badge--bump'));
      } else {
        this.badge.classList.remove('mobile-bottom-nav__badge--visible', 'mobile-bottom-nav__badge--bump');
      }
    } catch (e) {
      /* silently fail */
    }
  }

  initActiveState() {
    const currentPath = window.location.pathname;
    const items = this.nav.querySelectorAll('.mobile-bottom-nav__item');
    items.forEach(item => {
      const href = item.getAttribute('href') || '';
      if (href === currentPath || (href !== '/' && currentPath.startsWith(href))) {
        item.classList.add('mobile-bottom-nav__item--active');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new MobileBottomNav());
